import { GoodsReceivedNoteOption } from './SectionGoodsReceivedNote.types';

export const promoTemplateSettings = {
    isGrnEnabled: GoodsReceivedNoteOption.yes,
};
